import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [requires2fa, setRequires2fa] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password,
        totp_code: totpCode || null
      });

      if (response.data.requires_2fa) {
        setRequires2fa(true);
        toast.info('Please enter your 2FA code');
      } else {
        login(response.data.token, response.data.user);
        toast.success('Login successful!');
        navigate('/');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    }
  };

  return (
    <div className="grid lg:grid-cols-2 h-screen w-full">
      <div className="bg-slate-900 text-white p-10 flex flex-col justify-between relative overflow-hidden hidden lg:flex">
        <div className="relative z-10">
          <div className="text-3xl font-black tracking-tighter">TrackBuild.ca</div>
          <p className="mt-4 text-slate-300 text-lg">Manage construction projects with precision and clarity</p>
        </div>
        <div className="relative z-10">
          <p className="text-sm text-slate-400">Streamline submittals, RFIs, budgets, and change orders</p>
        </div>
        <div className="absolute inset-0 opacity-10">
          <img src="https://images.unsplash.com/photo-1760449867527-26d7d732f88e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwbW9kZXJuJTIwc2t5bGluZXxlbnwwfHx8fDE3NzA4MjY4MzB8MA&ixlib=rb-4.1.0&q=85" alt="" className="w-full h-full object-cover" />
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md space-y-8">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-slate-900">Sign in to your account</h2>
            <p className="mt-2 text-sm text-slate-600">Enter your credentials to access the platform</p>
          </div>
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2" data-testid="email-label">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900"
                placeholder="you@example.com"
                required
                data-testid="email-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2" data-testid="password-label">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900"
                placeholder="********"
                required
                data-testid="password-input"
              />
            </div>
            {requires2fa && (
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2" data-testid="2fa-label">2FA Code</label>
                <input
                  type="text"
                  value={totpCode}
                  onChange={(e) => setTotpCode(e.target.value)}
                  className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900"
                  placeholder="000000"
                  maxLength="6"
                  data-testid="2fa-input"
                />
              </div>
            )}
            <button
              type="submit"
              className="w-full bg-slate-900 text-white py-2 px-4 rounded-md hover:bg-slate-800 transition-colors"
              data-testid="login-button"
            >
              Sign in
            </button>
          </form>
          <div className="text-center space-y-2">
            <a href="/forgot-password" className="block text-sm text-slate-500 hover:text-slate-700" data-testid="forgot-password-link">Forgot your password?</a>
            <a href="/register" className="block text-sm text-blue-600 hover:underline" data-testid="register-link">Don't have an account? Register</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
